import { commonTexts, mapErrorCodeToUiMessage } from 'noddi-util';
import { ErrorPageBase } from './ErrorPageBase';
import { ApiErrorPageProps } from './types';

export const ApiErrorPage = ({ errorTitle, error, customCallback, translations, errorCodes }: ApiErrorPageProps) => {
  const apiErrorMessage = mapErrorCodeToUiMessage({ error, errorCodes });

  const handleCustomCallback = () => {
    customCallback?.callback() ?? window.location.reload();
  };

  const { title, tryAgain } = translations ?? commonTexts.errors;

  return (
    <ErrorPageBase
      title={errorTitle ?? title}
      description={apiErrorMessage}
      buttonProps={{
        buttonText: customCallback?.ctaText ?? tryAgain,
        onButtonClick: handleCustomCallback
      }}
    />
  );
};
